import React, { useId } from "react";
import moonSurface from "@/assets/moon-surface.webp";

// Lunar photograph: https://images.unsplash.com/photo-1592029383200-73fb26a5b925
// Disc-fitted, feathered-alpha 1400px WebP generated by /app/memory/make_moon.py.
export default function Moon({ size = 320, float = true, className = "", glow = true }) {
  const id = useId();

  return (
    <div
      className={`moon relative shrink-0 ${float ? "animate-floaty" : ""} ${className}`}
      style={{ width: size, height: size, fontSize: size }}
      data-testid={`moon-${id}`}
      aria-hidden="true"
    >
      {glow && <div className="moon-halo" />}
      <div className={`moon-surface ${glow ? "moon-glow" : ""}`}>
        <img
          src={moonSurface}
          alt=""
          className="moon-texture"
          width="1400"
          height="1400"
          decoding="async"
          draggable={false}
        />
      </div>
    </div>
  );
}
